export default __webpack_public_path__ + "static/treinamento02-94dd074d85b5b3fa8a990c473c6fed39.jpeg";